<template>
    <div v-if="job">
        <share-job :job="fullJob" :new-job="newJob" @back="backToPublishJob"/>
    </div>
</template>

<script>
import ShareJob from "../ShareJob";
import Job from '../../models/Job';
import {mapState} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../../state/modules/authentication';

export default {
    components: {
        ShareJob,
    },
    props: {
        job: Object,
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentCompanyId']),
        newJob (){
            return this.$route.name === 'jobs.create';
        },
        fullJob() {
            if(this.newJob){
               return this.job;
            }

            //Get latest data from job
            return useRepo(Job)
                .with('subscriptions', (q) => {
                    q.with('user');
                })
                .with('filters')
                .with('tags')
                .with('stages')
                .with('vdabJob')
                .with('attachments')
                .with('jobChannels')
                .where('company_id', this.currentCompanyId)
                .whereId(parseInt(this.job.id))
                .first();
        },
    },
    methods: {
        backToPublishJob() {
            this.$parent.setActiveTab(4);
        }
    },
    mounted() {
        if (this.newJob) {
            showConfetti();
        }
    }
}
</script>
